import { render } from "./TheNavigater.vue?vue&type=template&id=01d2cc9b&scoped=true"
import script from "./TheNavigater.vue?vue&type=script&lang=js"
export * from "./TheNavigater.vue?vue&type=script&lang=js"

import "./TheNavigater.vue?vue&type=style&index=0&id=01d2cc9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01d2cc9b"

export default script